/*
 * @Descripttion: 缓存相关
 * @version:
 * @Author: guoye
 * @Date: 2023-11-04 20:51:09
 * @LastEditors: guoye
 * @LastEditTime: 2025-07-14 18:13:41
 */
const Storage = {
  //获取storage信息
  getStorage: (type = 'pinia_custom') => {
    let storageInfo_local = {}
    let storageInfo_session = {}
    try {
      uni.getStorageInfo({
        success: function (res) {
          if (res.keys.includes(type)) {
            storageInfo_local = uni.getStorageSync(type) ? JSON.parse(uni.getStorageSync(type)) : {}
          } else {
            storageInfo_session = sessionStorage.getItem(type) ? JSON.parse(sessionStorage.getItem(type)) : {}
          }
        },
      })
    } catch (e) {
      console.log(42, 'e-->', e)
      //TODO handle the exception
    }

    let storageInfo = { ...storageInfo_local, ...storageInfo_session }
    // console.log('🔍 ~ getStorage ~ src/common/storage.js:29 ~ storageInfo:', storageInfo)

    return storageInfo
  },
}

export { Storage }
